<template>
  <transition name="modal">
    <div class="modal-mask" @click="$emit('close')">
      <div class="modal-wrapper">
        <div class="modal-container" @click.stop="">

          <button class="modal-close-button" aria-label="Закрыть" title="Закрыть" @click="$emit('close')">
            Закрыть
          </button>

          <div class="modal-header">

            <slot name="header">
              default header
            </slot>

          </div>

          <div class="modal-body">

            <slot name="body">
              default body
            </slot>

          </div>

          <div class="modal-footer">

            <slot name="footer">
              default footer
            </slot>

          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'vue-modal',
}
</script>

<style lang="scss" scoped>

  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    display: table;

    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;

    padding: 0 20px;
  }

  .modal-container {
    position: relative;

    width: 100%;
    max-width: 700px;

    max-height: calc(100vh - 40px);
    overflow: auto;

    margin: 0px auto;
    padding: 30px;

    font-family: Helvetica, Arial, sans-serif;

    background-color: #fff;
    border-radius: 15px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);

    transition: all 0.3s ease;
  }

  .modal-body {
    margin: 20px 0;
  }

  .modal-close-button {
    position: absolute;
    right: 0;
    top: 0;

    width: 40px;
    height: 40px;

    font-size: 0;
    color: transparent;

    background-color: transparent;
    border:0;

    &::before,
    &::after {
      content: '';

      position: absolute;
      left: 50%;
      top: 50%;

      display: block;

      width: 60%;
      height: 2px;

      background-color: #333;
      border-radius: 20px;
    }

    &::before {
      transform: translate(-50%, -50%) rotate(45deg);
    }

    &::after {
      transform: translate(-50%, -50%) rotate(-45deg);
    }

    &:hover,
    &:focus {
      opacity: 0.7;
    }
  }

  .modal-header {
    padding-bottom: 0;
    border-bottom: 0;
  }

  .modal-footer {
    padding-top: 0;
    border-top: 0;
  }

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

</style>

<style lang="scss">
.modal-header {
  h3 {
    margin-top: 0;
    color: #333;
  }
}
</style>
